<template>
  <transition name="popup-fade" @before-enter="beforeEnter">
    <div class="popup-backdrop" @click.self="close">
      <div class="popup">
        <recommendation-block v-for="(productRecommendation, index) in productRecommendations"
                              :product-recommendation="productRecommendation"
                              :index="index"
                              :key="index"/>
      </div>
    </div>
  </transition>
</template>

<script>

import { mapGetters } from 'vuex';
import RecommendationBlock from './RecommendationBlock.vue';

export default {
  name: 'recommendation-popup-block',
  components: { RecommendationBlock },
  props: {
    productRecommendations: { type: Array, required: true, default: () => [] },
  },
  computed: {
    ...mapGetters(['selectedLanguage'])
  },
  methods: {
    close() {
      this.$emit('close');
    },
    beforeEnter() {
      return 'ok';
    },
  },
};
</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  background-color: #dadada;
  box-shadow: rgba(0, 0, 0, 0.29) 5px 5px 25px 0;
  border-radius: 25px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 85%;
  max-width: 450px;
  height: fit-content;
  padding: 20px 20px 30px 20px;
}

.popup-title {
  text-align: center;
  color: black;
}

.popup-description {
  padding-top: 15px;
  height: fit-content;
}
</style>
